// extracted by mini-css-extract-plugin
export var placeholder = "bnuiF";
export var shrinkable = "dO5AA";
export var underlay = "dbRkh";